<template>
    <!-- 新大屏页面  单独控制了地图组件 -->
    <div class="home" :class="companyInfo.companyId === 2 ? 'bgimglw' : 'bgimg'">
        <div class="top">
            <div class="topLeft">

                <div class="title">
                    <span v-if="companyInfo.companyId === 2">智慧城市管理平台</span>
                    <span v-else>{{ companyInfo.companyName }}</span>
                    <el-tooltip class="item" effect="dark" placement="bottom">
                        <div slot="content">绿色表示链接正常,可实时获取设备信息<br />红色表示链接断开,重新登录或联系管理员</div>
                        <span
                            :class="websocketStatus ? 'iconfont icon-yuandian online' : 'iconfont icon-yuandian error'"></span>
                    </el-tooltip>
                </div>
            </div>
            <div class="topMiddle" v-if="companyInfo.companyId !== 2">
                <dv-decoration-5 class="dv-decoration" :color="[$store.state.maxThemeColor, $store.state.maxThemeColor]"
                    style="width: 100%; height: 2rem" :dur="5"></dv-decoration-5>
                <div class="titleText">
                    智慧城市管理平台
                </div>
            </div>
            <div class="topRight">
                <div class="menuList" @click="handleFullScreen" title="页面全屏">
                    <div class="iconfont icon-quanping"></div>
                    <div class="date">{{ fullscreen ? `退出全屏` : `页面全屏` }}</div>
                </div>

                <div class="menuList" @click="mapType = !mapType" title="切换地图类型">
                    <div class="iconfont icon-ditu"></div>
                    <div class="date">切换地图</div>
                </div>

                <div class="menuList" @click="fullMaxMap = !fullMaxMap" title="全屏地图">
                    <div class="iconfont icon-zaixianditu"></div>
                    <div class="date">全屏地图</div>
                </div>

                <!-- <div class="menuList" @click="$router.push('/maxWeb')" title="切换旧版">
                    <div class="iconfont icon-huamianjiance"></div>
                    <div class="date">切换旧版</div>
                </div> -->

                <!-- <div class="menuList" @click="$router.push('/ADashboard')" title="设备管理">
                    <div class="iconfont icon-xitongpeizhi"></div>
                    <div class="date">设备管理</div>
                </div>

                <div class="menuList" @click="$router.push('/ADashboard')" title="用户管理">
                    <div class="iconfont icon-xitongpeizhi"></div>
                    <div class="date">用户管理</div>
                </div>

                <div class="menuList" @click="$router.push('/ADashboard')" title="工单中心">
                    <div class="iconfont icon-xitongpeizhi"></div>
                    <div class="date">工单中心</div>
                </div> -->

                <div class="menuList" @click="$router.push('/ADashboard')" title="管理后台">
                    <div class="iconfont icon-xitongpeizhi"></div>
                    <div class="date">管理后台</div>
                </div>

                <div class="timeBox">
                    <div class="time">{{ nowTime.time }}</div>
                    <div class="date">{{ nowTime.date }} {{ nowTime.week }}</div>
                </div>
            </div>
        </div>
        <div class="content">
            <div v-if="!fullMaxMap" class="left">
                <div class="deviceStatus">
                    <leftcard1 v-if="dataStart" :deviceData="$store.state.deviceNowData"></leftcard1>
                </div>
                <div class="deviceType">
                    <leftcard2 v-if="dataStart"></leftcard2>
                </div>
                <div class="deviceCity">
                    <leftcard3 v-if="dataStart"></leftcard3>
                </div>
            </div>
            <div v-if="!fullMaxMap" class="mid">
                <echartsmap v-if="mapType && dataStart"></echartsmap>
                <tmap v-if="!mapType && dataStart"></tmap>
            </div>

            <div v-if="!fullMaxMap" class="right">
                <div class="taskCount">
                    <rightcard1 v-if="dataStart"></rightcard1>
                </div>
                <div class="taskType">
                    <rightcard2 v-if="dataStart"></rightcard2>
                </div>
                <div class="deviceAlarm">
                    <rightcard3 v-if="dataStart"></rightcard3>
                </div>
            </div>

            <!-- 全屏地图 -->
            <div v-if="fullMaxMap" class="fullMaxWeb">
                <echartsmap v-if="mapType && dataStart"></echartsmap>
                <tmap v-if="!mapType && dataStart"></tmap>
            </div>
        </div>

        <vue-particles color="#dddddd" :particleOpacity="0.7" :particlesNumber="70" shapeType="circle" :particleSize="4"
            linesColor="#409EFF" :linesWidth="1" :lineLinked="false" :lineOpacity="0.4" :linesDistance="150"
            :moveSpeed="2" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push"
            class="vueParticles">
        </vue-particles>
        <!--
      color: String类型。默认’#dedede’。粒子颜色。
      particleOpacity: Number类型。默认0.7。粒子透明度。
      particlesNumber: Number类型。默认80。粒子数量。
      shapeType: String类型。默认’circle’。可用的粒子外观类型有：“circle”,“edge”,“triangle”, “polygon”,“star”。
      particleSize: Number类型。默认80。单个粒子大小。
      linesColor: String类型。默认’#dedede’。线条颜色。
      linesWidth: Number类型。默认1。线条宽度。
      lineLinked: 布尔类型。默认true。连接线是否可用。
      lineOpacity: Number类型。默认0.4。线条透明度。
      linesDistance: Number类型。默认150。线条距离。
      moveSpeed: Number类型。默认3。粒子运动速度。
      hoverEffect: 布尔类型。默认true。是否有hover特效。
      hoverMode: String类型。默认true。可用的hover模式有: “grab”, “repulse”, + “bubble”。
      clickEffect: 布尔类型。默认true。是否有click特效。
      clickMode: String类型。默认true。可用的click模式有: “push”, “remove”, “repulse”, “bubble”。
     -->
    </div>
</template>

<script>
import leftcard1 from '@/components/common/maxWeb/leftcard1.vue';
import leftcard2 from '@/components/common/maxWeb/leftcard2.vue';
import leftcard3 from '@/components/common/maxWeb/leftcard3.vue';
import echartsmap from '@/components/common/maxWeb/echartsmap.vue';
import tmap from '@/components/common/maxWeb/tmap.vue';
import rightcard1 from '@/components/common/maxWeb/rightcard1.vue';
import rightcard2 from '@/components/common/maxWeb/rightcard2.vue';
import rightcard3 from '@/components/common/maxWeb/rightcard3.vue';

import { GetDeviceData, QueryAlermMessage, QueryCompanyProject } from '../../api/index';
import moment from 'moment';
import { io } from 'socket.io-client';
import uuid from 'short-uuid';
export default {
    data() {
        return {
            companyInfo: JSON.parse(localStorage.getItem('companyInfo')) ? JSON.parse(localStorage.getItem('companyInfo')) : {},
            nowTime: {
                date: '0000-00-00',
                time: '00:00:00',
                week: '000'
            }, // 当前时间
            mapType: false, // 地图类型 为true时是echarts  false是天地图
            fullMaxMap: false, // 是否全屏地图
            dataStart: false, //数据是否准备完成
            timer: null,
            fullscreen: false,
            websocketStatus: false
        };
    },
    created() {
        if (this.$route.query.userinfo && this.$route.query.companyInfo && this.$route.query.token) {
            this.companyInfo = JSON.parse(this.$route.query.companyInfo)
            window.localStorage.setItem('companyInfo', this.$route.query.companyInfo);
            window.localStorage.setItem('userinfo', this.$route.query.userinfo);
            window.localStorage.setItem('token', this.$route.query.token);
        }
        this.getNowTime();
        //根据公司id初始化首次进入时地图显示位置
        this.$store.commit('initMaxMapSetting', JSON.parse(localStorage.getItem('companyInfo')).companyId);
        // this.timer = setInterval(() => {
        //     this.getDeviceData();
        // }, 1000 * 60 * 5);
        this.getDeviceData();
        // 生产环境页面是 HTTPS 时，不能直连一个仅支持 HTTP 的 10111 端口（会触发 Mixed Content）。
        // 推荐在 Nginx/网关把 /socket.io 反代到 10111，然后前端连同源即可。
        const envSocketUrl = process.env.VUE_APP_SOCKET_URL;
        const origin = window.location.origin;
        const isHttpsPage = window.location.protocol === 'https:';

        // 生产环境建议始终走同源（由网关/Nginx 反代到真正的 socket 服务），避免 Mixed Content。
        const canUseEnvInThisBuild = process.env.NODE_ENV !== 'production';
        let socketBaseUrl = canUseEnvInThisBuild && envSocketUrl ? envSocketUrl : origin;

        // HTTPS 页面下，不允许使用任何非 HTTPS 的显式地址（包括 http://、//、不带协议等情况）。
        if (isHttpsPage) {
            socketBaseUrl = origin;
        }

        // 方便线上确认到底连到了哪里（如果仍报 http://www.sundaytek.com:10111，说明前端产物未更新/被缓存）。
        console.warn('[socket.io] baseUrl=', socketBaseUrl, 'env=', envSocketUrl, 'nodeEnv=', process.env.NODE_ENV);

        const socket = io(socketBaseUrl, { path: '/socket.io' });
        console.log(socket, 'socket--------------------');

        // 监听链接事件
        socket.on('connect', () => {
            // 发起登录

            socket.emit('login', localStorage.getItem('token'));
        });

        // 监听登录结果
        socket.on('loginResult', (data) => {
            if (data) {
                // 如果登录成功 发送roomId  [企业ID，用户id]
                socket.emit('roomId', `myroom${JSON.parse(localStorage.getItem('companyInfo')).companyId},${uuid.generate()}`);
                this.websocketStatus = true;
            }
        });

        // 监听数据更新事件
        socket.on('data', (data) => {
            // 修改vuex中的数据
            this.$store.commit('setOneDeviceData', data);
            if (data.projectId == 'SDszjc') {
                console.log(data, 'value----SDszjc');
            }
            console.log('有设备数据更新');
            console.log(data);
            this.formatAlarmDevice(this.$store.getters.getNewDeviceData);
        });

        // 监听关闭事件
        socket.on('disconnect', () => {
            this.websocketStatus = false;
        });

        socket.on('error', () => {
            this.websocketStatus = false;
        });
    },
    mounted() { },
    methods: {
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
        // 获取当前时间
        getNowTime() {
            setInterval(() => {
                this.nowTime.date = moment(new Date()).format('YYYY-MM-DD');
                this.nowTime.time = moment(new Date()).format('HH:mm:ss');
                switch (moment(new Date()).day()) {
                    case 1:
                        this.nowTime.week = '星期一';
                        break;
                    case 2:
                        this.nowTime.week = '星期二';
                        break;
                    case 3:
                        this.nowTime.week = '星期三';
                        break;
                    case 4:
                        this.nowTime.week = '星期四';
                        break;
                    case 5:
                        this.nowTime.week = '星期五';
                        break;
                    case 6:
                        this.nowTime.week = '星期六';
                        break;
                    case 0:
                        this.nowTime.week = '星期日';
                        break;
                    default:
                        break;
                }
            }, 1000);
        },

        // 获取当前设备数据
        async getDeviceData() {
            let companyId = JSON.parse(localStorage.getItem('companyInfo')).companyId;
            let DevicelistResult = await GetDeviceData({ companyId });
            if (DevicelistResult.code !== 200) {
                this.$message.error('获取设备数据错误');
                return;
            }
            // 修改vuex中的设备数据
            this.$store.commit('setDeviceNowData', DevicelistResult.data);
            console.log('父组件的数据');
            console.log(this.$store.state.deviceNowData);
            this.formatAlarmDevice(DevicelistResult.data);
            // 数据准备完成
            this.dataStart = true;
        },
        // 格式化当前设备报警信息
        formatAlarmDevice(data) {
            console.log('更新设备报警信息执行');
            // 判断是否有设备是否触发报警条件 如果触发则修改报警记录
            let messageArr = [];
            data.forEach((item, index) => {
                switch (item.deviceType) {
                    case '智能井盖':
                        if (item.alarmStatus) {
                            messageArr.push({
                                messageId: index,
                                type: 'alarm',
                                info: '井盖打开',
                                id: item.anotherName ? item.anotherName : item.deviceName,
                                deviceData: item,
                                failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                successDate: '',
                                status: 0
                            });
                        }
                        break;
                    case '智能井盖L3W':
                        if (item.alarmStatus) {
                            messageArr.push({
                                messageId: index,
                                type: 'alarm',
                                info: '井盖报警',
                                id: item.anotherName ? item.anotherName : item.deviceName,
                                deviceData: item,
                                failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                successDate: '',
                                status: 0
                            });
                        }
                        break;
                    case '水位流速监测':
                        if (item.alarmStatus) {
                            messageArr.push({
                                messageId: index,
                                type: 'alarm',
                                info: '水位超限',
                                id: item.anotherName ? item.anotherName : item.deviceName,
                                deviceData: item,
                                failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                successDate: '',
                                status: 0
                            });
                        }
                        break;
                    case '雨量监测':
                        if (item.alarmStatus) {
                            messageArr.push({
                                messageId: index,
                                type: 'alarm',
                                info: '雨量超限',
                                id: item.anotherName ? item.anotherName : item.deviceName,
                                deviceData: item,
                                failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                successDate: '',
                                status: 0
                            });
                        }
                        break;
                    case '智能井盖4G':
                        if (item.alarmStatus) {
                            messageArr.push({
                                messageId: index,
                                type: 'alarm',
                                info: '井盖报警',
                                id: item.anotherName ? item.anotherName : item.deviceName,
                                deviceData: item,
                                failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                successDate: '',
                                status: 0
                            });
                        }
                        break;
                    case '智能井盖V4':
                        if (item.alarmStatus) {
                            messageArr.push({
                                messageId: index,
                                type: 'alarm',
                                info: '井盖报警',
                                id: item.anotherName ? item.anotherName : item.deviceName,
                                deviceData: item,
                                failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                successDate: '',
                                status: 0
                            });
                        }
                        break;
                    case '积水监测':
                        if (item.alarmStatus) {
                            messageArr.push({
                                messageId: index,
                                type: 'alarm',
                                info: '水位超限报警',
                                id: item.anotherName ? item.anotherName : item.deviceName,
                                deviceData: item,
                                failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                successDate: '',
                                status: 0
                            });
                        }
                        break;
                    case '雷达水位计':
                        if (item.alarmStatus) {
                            messageArr.push({
                                messageId: index,
                                type: 'alarm',
                                info: '水位超限报警',
                                id: item.anotherName ? item.anotherName : item.deviceName,
                                deviceData: item,
                                failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                successDate: '',
                                status: 0
                            });
                        }
                        break;
                    case '不锈钢井盖':
                        if (item.alarmStatus) {
                            messageArr.push({
                                messageId: index,
                                type: 'alarm',
                                info: '井盖开锁',
                                id: item.anotherName ? item.anotherName : item.deviceName,
                                deviceData: item,
                                failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                successDate: '',
                                status: 0
                            });
                        }
                        break;
                    case '水质监测':
                        if (item.alarmStatus) {
                            if (item.phAlarmStatus) {
                                messageArr.push({
                                    messageId: index,
                                    type: 'alarm',
                                    info: 'PH值异常报警',
                                    id: item.anotherName ? item.anotherName : item.deviceName,
                                    deviceData: item,
                                    failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                    successDate: '',
                                    status: 0
                                });
                            }
                            if (item.waterAlarmStatus) {
                                messageArr.push({
                                    messageId: index,
                                    type: 'alarm',
                                    info: '液位值异常报警',
                                    id: item.anotherName ? item.anotherName : item.deviceName,
                                    deviceData: item,
                                    failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                    successDate: '',
                                    status: 0
                                });
                            }
                            if (item.codAlarmStatus) {
                                messageArr.push({
                                    messageId: index,
                                    type: 'alarm',
                                    info: 'COD值异常报警',
                                    id: item.anotherName ? item.anotherName : item.deviceName,
                                    deviceData: item,
                                    failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                    successDate: '',
                                    status: 0
                                });
                            }
                            if (item.ecAlarmStatus) {
                                messageArr.push({
                                    messageId: index,
                                    type: 'alarm',
                                    info: 'EC值异常报警',
                                    id: item.anotherName ? item.anotherName : item.deviceName,
                                    deviceData: item,
                                    failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                    successDate: '',
                                    status: 0
                                });
                            }

                        }
                        break;
                    default:
                        break;
                }
            });
            this.$store.commit('setAlarmMessage', messageArr);
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    components: {
        leftcard1,
        leftcard2,
        leftcard3,
        rightcard1,
        rightcard2,
        rightcard3,
        echartsmap,
        tmap
    }
};
</script>

<style lang="less" scoped>
.bgimglw {
    background-image: url('../../assets/img/bgimg6.jpg');
}

.bgimg {
    background-image: url('../../assets/img/maxwebImg/testIBgcmg.jpg');
}

.home {
    padding: 0;
    border: 0;
    font-size: 0.5rem;
    width: 100vw;
    height: 100vh;
    // background-image: url('../../assets/img/maxwebImg/testIBgcmg.jpg');
    background-size: 100% 100%;
    background-position: 0 0;
    color: #dbe0e3;
    box-sizing: border-box;


    .top {
        height: 9vh;
        width: 100vw;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #14283e;
        position: relative;
        z-index: 99;

        .topLeft {
            display: flex;
            align-items: center;
            width: 530px;

            .title {
                font-size: 0.7rem;
                font-weight: bold;
                letter-spacing: 0.1rem;
                display: flex;
                align-items: center;

                .online {
                    margin-left: 0.2rem;
                    font-size: 0.3rem;
                    font-weight: bold;
                    color: #33cc99;
                }

                .error {
                    margin-left: 0.2rem;
                    font-size: 0.3rem;
                    font-weight: bold;
                    color: #b33105;
                }
            }
        }


        .topMiddle {
            position: relative;
            height: 100%;
            width: 800px;
            top: 0;
            font-size: 0.7rem;
            font-weight: bold;

            .dv-decoration {
                position: absolute;
                top: 0;
            }

            .titleText {
                color: #fff;
                text-align: center;
                font-size: 0.8rem;
            }
        }

        .topRight {
            display: flex;
            justify-content: end;
            align-items: center;
            width: 400px;

            .menuList {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                font-size: 0.2rem;
                margin-right: 0.3rem;
                cursor: pointer;
                transition: all 0.3s;

                .iconfont {
                    font-size: 0.4rem;
                    margin-bottom: 0.1rem;
                }
            }

            .menuList:hover {
                color: aqua;
            }

            .timeBox {
                display: flex;
                flex-direction: column;
                text-align: center;

                .time {
                    color: aqua;
                    font-size: 0.7rem;
                }

                .date {
                    display: flex;
                    flex-wrap: nowrap;
                    font-size: 0.3rem;
                    color: #ccc;
                }
            }
        }
    }

    .content {
        padding: 0;
        height: 90vh;
        width: 100vw;
        display: flex;
        box-sizing: border-box;
        position: relative;
        z-index: 99;
        padding: 10px;

        .fullMaxWeb {
            width: 100%;
            height: 100%;
        }

        .left {
            width: 27vw;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .deviceStatus {
                height: 30vh;
                width: 27vw;
                background-color: rgba(0, 0, 0, 0.3);
            }

            .deviceType {
                height: 35vh;
                width: 27vw;
                background-color: rgba(0, 0, 0, 0.3);
            }

            .deviceCity {
                height: 20vh;
                width: 27vw;
                background-color: rgba(0, 0, 0, 0.3);
            }
        }

        .mid {
            width: 55vw;
            position: relative;
            box-sizing: border-box;
            border: 1px solid #14283e;
        }

        .right {
            width: 18vw;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .taskCount {
                width: 18vw;
                height: 16vh;
            }

            .taskType {
                width: 18vw;
                height: 30vh;
                // background-color: rgb(40, 57, 153);
                background-color: rgba(0, 0, 0, 0.3);
            }

            .deviceAlarm {
                width: 18vw;
                height: 36vh;
                // background-color: rgb(29, 150, 65);
                background-color: rgba(0, 0, 0, 0.3);
            }
        }
    }

    .content::-webkit-scrollbar {
        display: none;
    }
}

.vueParticles {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
}
</style>